import React from 'react';

import { wrapper } from './height-space.module.scss';

const HeightSpace = () => {
    return <div className={wrapper} />;
};

export default HeightSpace;
